class Shop {
    constructor(connectionManager) {
        connectionManager.addListener(this);
        connectionManager.addHandler(this.terminal, 'cego:xmpp:notification:shop');
        this.payments = [];
    }

    onConnected() {
        return true;
    }

    onDisconnected() {
        return true;
    }

    terminal(message) {
        let data = app.util.jsonDecode(message.querySelector("body").innerHTML);
        if (data) {
            data = data.data;
            switch (data.state) {
                case "success":
                    app.shop.status(data.id);
                    break;
                case "failed":
                case "error":
                    app.shop.status(data.id, false);
                    app.shop.reloadItems();
                    break;
                case "cancelled":
                    app.shop.status(data.id);
                    app.shop.reloadItems();
                    break;
                case "need_source":
                case "need_input":
                    app.shop.reloadItems();
                    break;
                case "pending":
                    if (app.shop.changed(data.id, data.state)) {
                        app.shop.status(data.id);
                        app.shop.reloadItems();
                    }
                    break;
            }
        }
        return true;
    }

    reload() {
        if (jQuery("#vip,#shop").length) {
            window.location.reload();
        }
    }

    reloadItems() {
        if (jQuery("#vip #items").length) {
            app.ajax.reload("#items");
        }
    }

    update(id, data = {}, onSuccess = null) {
        let values = $("#details").serialize();
        if (values) {
            Object.assign(data, app.util.queryStringToJSON(values));
        }
        app.ajax.post('/services/shop/payment/update/' + id, {"data": data}, onSuccess, onSuccess);
    }

    showProcessing() {
        jQuery("#processing").fadeIn(300);
    }

    hideProcessing() {
        jQuery("#processing").fadeOut(300);
    }

    checkTermsAndAge() {
        let age = document.getElementById("accept_age");
        if (document.getElementById("accept_terms").checked && (!age || age.checked)) {
            $("#buy-button").slideDown(50);
        } else {
            $("#buy-button").slideUp(50);
        }
    }

    buy(ev) {

        this.hideMessage();
        this.showProcessing();
        this.buyFunction(ev);
    }


    pending(id) {
        app.ajax.post("/services/shop/payment/pending/" + id);
    }

    change(id) {
        app.ajax.post("/services/shop/change/" + id);
    }

    cancel(id, doClose = true) {
        app.ajax.delete("/services/shop/cancel/" + id);
        if (doClose) {
            app.modal.close();
        }
    }

    cancelled() {
        if (document.documentURI.indexOf("play") === -1) {
            app.ajax.reload("#page");
        }
    }

    changed(id, state) {
        if (typeof this.payments[id] === "undefined" || this.payments[id] !== state) {
            this.payments[id] = state;
            return true;
        } else {
            return false;
        }
    }

    status(id, closeModal = true) {
        if (jQuery("#vip,#shop,.payment-modal").length) {
            if (closeModal) {
                app.modal.close(function () {
                    app.ajax.get("/services/shop/payment/status/" + id);
                });
            } else {
                app.ajax.get("/services/shop/payment/status/" + id);
            }
        } else {
            if ($("#custom_shop_payment").length === 1) {
                app.ajax.reload("#custom_shop_payment");
            }
        }
    }

    message(message) {
        jQuery("#shop_user_payment #message").html(message).slideDown(300);
        this.hideProcessing();
    }

    hideMessage() {
        jQuery("#shop_user_payment #message").slideUp(300).html("");
    }

    init() {
        this.element = null;
        this.methods = null;
        this.method = null;
        this.bank = null;
        this.name = null;
        this.paymentRequest = null;
    }

    initConfirm(id) {
        this.buyFunction = () => {
            this.update(id, {func: "confirm"});
        }
    }

    initStripe(onLoad) {
        this.init();

        if (typeof app.shop.stripe === "undefined") {
            const stripeJs = document.createElement('script');
            stripeJs.src = 'https://js.stripe.com/v3/';
            stripeJs.async = true;
            stripeJs.onload = () => {
                app.shop.stripe = Stripe(app.config.stripePublicKey);
                app.shop.stripeElements = app.shop.stripe.elements({
                    locale: app.config.language_code
                });
                onLoad();
            };
            document.body && document.body.appendChild(stripeJs);

        } else {
            onLoad();
        }
    }

    initStripeCreditCard(secret, id) {
        this.initStripe(() => {
            if (typeof this.cardElement === "undefined") {
                this.cardElement = app.shop.stripeElements.create('card', {hidePostalCode: true});
            }
            this.cardElement.mount('#card-element');
            this.initMethodSelector();
        });
        this.buyFunction = () => {
            app.shop.stripe.confirmCardPayment(
                secret,
                app.shop.method
            ).then((result) => {
                if (result.error) {
                    this.message(result.error.message);
                } else {
                    this.pending(id);
                }
            });
        };
    }

    initStripeIdeal(id) {
        this.initStripe(() => {
            if (typeof this.idealElement === "undefined") {
                this.idealElement = this.stripeElements.create('idealBank', {
                    style: {
                        base: {
                            padding: '10px 12px',
                            color: '#32325d',
                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                            fontSmoothing: 'antialiased',
                            fontSize: '16px',
                            '::placeholder': {
                                color: '#aab7c4'
                            },
                        },
                        invalid: {
                            color: '#fa755a',
                        }
                    }
                });
                this.idealElement.on('change', (ev) => {
                    this.bank = ev.value;
                });
            }
            this.idealElement.mount('#ideal-bank-element');
        });

        this.buyFunction = () => {
            this.update(id, {"name": jQuery('#ideal #name').val(), "bank": this.bank},
                (response) => {
                    if (response.status === "pending") {
                        window.open(response.redirect.url);
                    } else {
                        this.message(response.error);
                    }
                },
                (response) => {
                    this.message(response.error);
                });
        };
    }

    initGiroPay(id) {
        this.init();
        this.buyFunction = () => {
            this.update(id, {"name": jQuery('#giropay #name').val()},
                (response) => {
                    if (response.status === "pending") {
                        window.open(response.redirect.url);
                    } else {
                        this.message(response.error);
                    }
                },
                (result) => {
                    this.message(result.error);
                });
        }
    }

    initSofort(id) {
        this.init();
        this.buyFunction = () => {
            this.update(id, {"name": jQuery('#sofort #name').val()},
                (response) => {
                    if (response.status === "pending") {
                        window.open(response.redirect.url);
                    } else {
                        this.message(response.error);
                    }
                },
                (result) => {
                    this.message(result.error);
                });
        }
    }

    // initSepa(id)
    // {
    //     this.initStripe();
    //     let style = {
    //         base: {
    //             color: '#32325d',
    //             fontFamily: '"open sans", helvetica, arial, sans-serif',
    //             fontSmoothing: 'antialiased',
    //             fontSize: '16px',
    //             '::placeholder': {
    //                 color: '#aab7c4'
    //             },
    //             ':-webkit-autofill': {
    //                 color: '#32325d',
    //             },
    //         },
    //         invalid: {
    //             color: '#fa755a',
    //             iconColor: '#fa755a',
    //             ':-webkit-autofill': {
    //                 color: '#fa755a',
    //             },
    //         }
    //     };
    //     let bank = jQuery('#bank-name');
    //     let ibanElement = this.stripeElements.create('iban', {
    //         style: style,
    //         supportedCountries: ['SEPA'],
    //     });
    //     ibanElement.mount('#iban');
    //
    //     this.initMethodSelector();
    //
    //     ibanElement.on('change', (event) => {
    //         if (event.error) {
    //             this.message(event.error.message);
    //         } else {
    //             this.hideMessage();
    //         }
    //         if (event.bankName) {
    //             bank.html(event.bankName).slideDown();
    //         } else {
    //             bank.slideUp().html("");
    //         }
    //     });
    //
    //     this.buyFunction = () => {
    //         if (this.method) {
    //             this.update(id, {sourceId: this.method.payment_method}, (response) => {
    //                 if (response.status === "chargeable") {
    //                 } else {
    //                     this.message(response.error);
    //                 }
    //             });
    //         } else {
    //             let sourceData = {
    //                 type: 'sepa_debit',
    //                 currency: 'eur',
    //                 owner: {
    //                     name: document.querySelector('input[name="name"]').value,
    //                     email: document.querySelector('input[name="email"]').value,
    //                 },
    //                 mandate: {
    //                     notification_method: 'email',
    //                 }
    //             };
    //             this.stripe.createSource(ibanElement, sourceData).then((result) => {
    //                 if (result.error) {
    //                     this.message(result.error.message);
    //                 } else {
    //                     this.update(id, {sourceId: result.source.id}, (response) => {
    //                         if (response.status !== "chargeable") {
    //                             this.message(response.error);
    //                         }
    //                     });
    //                 }
    //             });
    //         }
    //     };
    // }

    initBankTransfer(id) {
        this.init();
        this.buyFunction = () => {
            this.update(id);
        }
    }


    initReepayCreditCard(id) {
        this.init();
        this.buyFunction = () => {
            this.update(id);
        }
    }

    initReepayPaypal(id) {
        this.init();
        this.buyFunction = () => {
            this.update(id);
        }
    }

    initMobilepay(id) {
        this.init();
        this.buyFunction = () => {
            this.update(id, {phone: $("#mobilepay #phone").val()});
        }
    }

    initRapydCheckout(id) {
        this.init();
        this.buyFunction = () => {
            this.update(id);
        }
    }

    initAltapay(id) {
        this.init();
        this.buyFunction = () => {
            this.update(id);
        }
    }

    initMethodSelector() {
        this.methods = jQuery("#shop_user_payment #methods");
        if (this.methods.find("option").length > 1) {
            this.method = {payment_method: this.methods.val()};
            jQuery("#payment-details").hide();
            this.methods.change(() => {
                if (this.methods.val()) {
                    this.method = {payment_method: this.methods.val()};
                    jQuery("#payment-details").slideUp(200);
                } else {
                    jQuery("#payment-details").slideDown(200);
                    this.method = {payment_method: {card: app.shop.cardElement}}
                }
            });
        } else {
            this.method = {payment_method: {card: app.shop.cardElement}};
        }
    }
}
